import React, { Fragment, useState } from "react";

import Support from "../assets/images/chatIcon-white.svg";
import Close from "../assets/images/svgs/close 1.png";
import ChatImg from "../assets/images/svgs/chatting 1.png";
import UpArrow from "../assets/images/svgs/up-arrow.svg";

const Chat = () => {
  const [chatOpen, setChatOpen] = useState(false);
  return (
    <Fragment>
      {chatOpen && (
        <div className="chat-container border-2">
          <p className="p-2 fw-bold text-white text-center m-auto">
            Messages
            <img
              draggable="false"
              loading="lazy"
              src={Close}
              className="position-absolute end-0 mx-3 cursor-pointer svg-icon"
              alt=""
              onClick={() => {
                setChatOpen(false);
              }}
            />
          </p>
          <hr />

          <div className="position-absolute bottom-0 w-100">
            <hr />
            <div>
              <p className="text-white text-center m-auto">
                <img
                  draggable="false"
                  loading="lazy"
                  src={ChatImg}
                  className="w-20px svg-icon"
                  alt=""
                />
                <p className="fs-10">Message</p>
              </p>
            </div>
          </div>
        </div>
      )}

      <div
        className="chat-div p-1 text-center cursor-pointer"
        onClick={() => {
          setChatOpen(!chatOpen);
        }}
      >
        {chatOpen && (
          <img
            draggable="false"
            loading="lazy"
            src={UpArrow}
            alt=""
            className="w-80 mt-1 svg-icon"
          />
        )}

        {!chatOpen && (
          <img
            draggable="false"
            loading="lazy"
            src={Support}
            alt=""
            className="w-80 mt-1 svg-icon"
          />
        )}
      </div>
    </Fragment>
  );
};

export default Chat;
